import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { usePreferences } from '../contexts/PreferencesContext';

const UserProfile: React.FC = () => {
  const { user, logout } = useAuth();
  const { preferences, toggleOnHold } = usePreferences();
  const [showDropdown, setShowDropdown] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    try {
      setLoggingOut(true);
      await logout();
    } catch (error) {
      console.error('Failed to log out:', error);
    } finally {
      setLoggingOut(false);
      setShowDropdown(false);
    }
  };

  if (!user) return null;

  return (
    <div className="user-profile">
      <div 
        className="profile-button"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <img 
          src={user.photoURL || '/default-avatar.png'} 
          alt={user.displayName || 'User'} 
          className="profile-avatar"
          onError={(e) => {
            (e.target as HTMLImageElement).src = 'https://via.placeholder.com/32x32?text=👤';
          }}
        />
        <span className="profile-name">
          {user.displayName || user.email}
        </span>
        <span className="dropdown-arrow">▼</span>
      </div>

      {showDropdown && (
        <div className="profile-dropdown">
          <div className="dropdown-header">
            <img 
              src={user.photoURL || '/default-avatar.png'} 
              alt={user.displayName || 'User'} 
              className="dropdown-avatar"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://via.placeholder.com/48x48?text=👤';
              }}
            />
            <div className="dropdown-user-info">
              <div className="dropdown-name">{user.displayName}</div>
              <div className="dropdown-email">{user.email}</div>
            </div>
          </div>
          
          <div className="dropdown-divider"></div>

          <div className="preferences-section">
            <div className="preference-item">
              <label className="preference-label">
                <input
                  type="checkbox"
                  checked={preferences.showOnHold}
                  onChange={toggleOnHold}
                  className="preference-checkbox"
                />
                <span className="preference-text">Show "On Hold" status</span>
              </label>
            </div>
          </div>

          <div className="dropdown-divider"></div>

          <button
            className="dropdown-item logout-btn"
            onClick={handleLogout}
            disabled={loggingOut}
          >
            {loggingOut ? 'Signing out...' : 'Sign Out'}
          </button>
        </div>
      )}

      {showDropdown && (
        <div 
          className="dropdown-overlay"
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
};

export default UserProfile;